<template>
    <div class="navBox" :class="$route.query.nw == 1 ? 'crm-navigation pointer-events' : 'crm-navigation'">
        <div class="header-logo">
            松鼠AI, 乂学, 乂学教育, CRM
        </div>
        <div v-if="menu" style="float:left;width: calc(100% - 700px);">
            <el-tabs v-model="id" @tab-click="handleClick">
                <el-tab-pane v-for="item in menu" :key="item.NavigationId" :item="item" :label="item.Title" :name="String(item.NavigationId)">
                    {{item}}
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="user-info">
            <!-- v-if="userInfo.CallCenterType != 5" -->
            <div class="info-messge">
                <span class="call-time">
                    <span>通话时长:</span>
                    <span>{{this.duration}}</span>
                    <i></i>
                </span>
                <span class="messge-call">
                    <span>通话次数:</span>
                    <span>{{this.callCount}}</span>
                </span>
                <span class="email-icon" @click="onMessageList">
                    <i></i>
                    <span class="email-num">
                        <span>{{$store.state.home.getMessageCount}}</span>
                    </span>
                </span>
            </div>
            <div class="can-work">
                <!-- v-if="userInfo.CallCenterType != 5" -->
                <el-dropdown style="margin-right: 3px" @command="handleExtCommands">
                    <span :class="{'el-dropdown-call':true,'el-dropdown-callIn': (this.extStatusId===4||this.isCalling===1),'el-dropdown-call-unsign':this.extStatusId===1&&this.isCalling!==1,'el-dropdown-call-busy':this.extStatusId===3&&this.isCalling!==1,'el-dropdown-call-idle':this.extStatusId===2&&this.isCalling!==1}">
                        <span>{{this.extStatus}}</span>
                        <i class="el-icon-caret-bottom el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="signIn" :disabled="signIn" v-show="callState">签入</el-dropdown-item>
                        <el-dropdown-item command="signOut" :disabled="singOut">签出</el-dropdown-item>
                        <el-dropdown-item command="setIdle" :disabled="setIdle">置闲</el-dropdown-item>
                        <el-dropdown-item command="setBusy" :disabled="setBusy">置忙</el-dropdown-item>
                        <el-dropdown-item command="setMonitor" :disabled="setMonitor">监控</el-dropdown-item>
                        <el-dropdown-item command="setHangup" :disabled="setHangup">挂断</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown trigger="hover" @command="handleCommands">
                    <div class="el-dropdown-link-2">
                        <span class="beyond-hidden FL" style="max-width: 150px;">{{this.TrueName}}</span>
                        <i class="el-icon-caret-bottom el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="logout">注销退出</el-dropdown-item>
                        <!-- <el-dropdown-item command="passwordModify">修改密码</el-dropdown-item> -->
                        <el-dropdown-item command="extension">话务配置</el-dropdown-item>
                        <el-dropdown-item command="qrCode">二维码</el-dropdown-item>
                        <el-dropdown-item command="export">导出下载</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <a href="javascript:void(0)" class="switched-systems">
                    <i></i>
                </a> -->
            </div>
        </div>
        <el-dialog class="nav-extension" title="话务配置" :visible.sync="isExtension">
            <el-form :model="form" ref="form">
                <el-form-item label="请选择话务系统:" label-width="130px">
                    <el-select size="small" style="width: 100%" v-model="form.system" placeholder="请选择话务系统">
                        <el-option v-for="item in CallCenterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-row v-show="isCenterType">
                    <el-form-item label="传统OB分机号:" label-width="130px">
                        <el-input size="small" style="width: 100%" v-model="form.PartialPhone" auto-complete="off"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <p class="crm-system-msg">注：话务配置成功后，需退出重新登录！</p>
            <div style="text-align: right">
                <el-button size="small" @click="isExtension = false">取 消</el-button>
                <el-button size="small" :loading="sysLoading" type="primary" @click="onDialogSave">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog
        :visible.sync="dialogVisible"
        width="200px"
        :before-close="handleClose">
            <img class="qr_img" :src="qr_img">
        </el-dialog>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex';
    import { getCallStatus } from '../api/callCenter';
    import { EditUser, UserLogOut, CheckIpAddress } from '../api/login';
    import { setCookie } from 'cookieUtils';
    import { parseUrl } from 'base';
    import { getEnv } from '../util/config';
    import Modal from 'vueModal';
    import { hangupCall,tianrunCCLogin,signAliYunCC,initFeiyu } from '../util/util';
    import { signTianRunYunCC } from '../util/tianrunCall';
    import {
        CRM_MENU,
        CRM_USER_INFO,
        CRM_TOKEN,
        CRM_OPEN_TABS,
        CRM_CURRENT_LEVEL_ONE_MENU,
        CRM_USER_DEPARTMENT,
        CRM_CERTIFICATES_TYPE,
        CRM_INTENTION_STUDENTS,
        CRM_PROVICE_CITY,
        CRM_CLUES_STATUS,
        CRM_INTENTION_DEGREE,
        CRM_CUSTONER_SOURE,
        CRM_CHANNERLS,
        CRM_CLUES_OPTIMAL,
        CRM_PROFESSIONAL_STATUS,
        CRM_TRAFFIC_STATUS,
        CRM_LABE_LIST,
        CRM_URGENCY,
        CRM_INTENTTION_DEGREE,
        CRM_LATEST_AJAX_TIME,
    } from '../util/keys';
    import {GetSupervisionUrl} from "~/js/api/navbar";

    let signFlag = null;
    import login_myyixue from '../../img/login_myyixue.png'
    import login_songshuai from '../../img/login_songshuai.png'
    export default {
        data() {
            return {
                CallCenterType: [{label: 'OB', value: '1'}],
                sysLoading: false,
                isExtension: false,
                name: 'linxin',
                callNum: '',
                userInfo: {
                    PartialPhone: '',
                    UserId: '',
                    CallCenterType: '',
                    WorkNo: ''
                },
                dialogVisible: false,
                signIn: false,
                singOut: true,
                setIdle: true,
                setBusy: true,
                setMonitor: true,
                setHangup: true,
                setOnLine: true,
                isCenterType: true,
                messageCount:0,
                isCalling:0,
                form: {
                    system: '1',
                    systemInfo : '',
                    PartialPhone: ''
                },
                /*menu: function(){
                    return JSON.parse(localStorage.getItem(CRM_MENU))
                },*/
                activeName: '',
                extStatus:'',
                signFlag: null,
                callState: true,
            }
        },
        created() {
            let userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
            if(userInfo) {
                this.userInfo = userInfo
                this.getCallInfo();
                this.$store.dispatch('GetUnreadMessageCount');
            }
            // initFeiyu()
            // if(userInfo && userInfo.CallCenterType == 5){
            //     initFeiyu()
            // }
            this.getExtStatus();
            this.$store.dispatch('initCurrentLevelOneId');  // 记录一级菜单ID
            this.$store.dispatch('updateCurrentSubMenu', this.$store.state.navigation.currentLevelOneId);   // 根据一级菜单ID找到二级菜单
            CheckIpAddress().then(ret=>{
                if (ret.status === 0) {
                    if (ret.result){
                        this.callState = true
                    } else {
                        this.callState = false
                    }
                }
            }).catch(()=>{

            })
        },
        mounted() {
            let nid = localStorage.getItem(CRM_CURRENT_LEVEL_ONE_MENU)
            if (parseUrl().nw != 1 && !nid) {
                nid = '489';
                for (var i in this.menu) {
                    if (this.menu[i].NavigationId == nid) {
                        this.updateCurrentSubMenu(this.menu[i]);
                        break;
                    }
                }
            }

            const {TrHotLine, SysAliyunMq, CallCenterType, PartialPhone, Mobile} = this.userInfo;
            this.form.PartialPhone = PartialPhone;
            this.form.system = (!CallCenterType || CallCenterType == 0) ? '1' : CallCenterType.toString();


            if (this.form.system == '1') {
                this.isCenterType = true;
            } else {
                this.isCenterType = false;
            }
            if (TrHotLine && TrHotLine.length) {
                this.CallCenterType.push({label: '天润', value: '3'});
            }
            if (SysAliyunMq && SysAliyunMq.length) {
                this.CallCenterType.push({label: '阿里云', value: '2'});
            }
            if (true) {
                this.CallCenterType.push({label: '汉天', value: '4'});
                this.CallCenterType.push({label: '飞鱼', value: '5'});
            }
        },
        computed: {
            qr_img(){
                let hostName = location.hostname
                // return hostName.indexOf('pangu.songshuai.com') ? '../../img/login_songshuai.png' : '../../img/login_myyixue.png';
                return hostName.indexOf('pangu.songshuai.com') >= 0 ? login_songshuai : login_myyixue;
            },
            menu() {
                return JSON.parse(localStorage.getItem('CRM_MENU'))
            },
            TrueName() {
                return this.userInfo.TrueName
            },
            workNo() {
                return this.userInfo.WorkNo
            },
            ...mapState({
                duration: state => state.navbar.callDuration,
                callCount: state => state.navbar.callCount,
                id: state => {
                    return String(state.navigation.currentLevelOneId);
                },
                extStatusId: state => {
                    return state.navigation.extStatusId;
                },
                aliCallStatus: state => {
                    return state.navigation.aliCallStatus;
                },
                trCCEventName:state=>{
                    return state.navigation.trCCEventName;
                },
                trState:state=>{
                    return state.navigation.trCludeStatus.state;
                },
                trStateAction:state=>{
                    return state.navigation.trCludeStatus.stateAction;
                }
            })
        },
        watch: {
            extStatusId: function(val) {
                this.setExtStatus(val);
                if(val !== 1){
                    this.shouldSingOut();
                }
            },
            aliCallStatus:function(val){
                this.setAliStatus(val);
            },
            trCCEventName:function(val){
                this.setTrStatus(val);
            },
            trState:function(val){
                console.log('tianrun status',val);
                this.setTrCludeStatus(val);
            },
            'form.system': function(val) {
                if (val == '1') {
                    this.isCenterType = true;
                } else {
                    this.isCenterType = false;
                }
            },

        },
        methods: {
            handleClose () {
                this.dialogVisible = false;
            },
            // 三小时没有任何操作签出
            shouldSingOut(){
                let self = this;
                clearInterval(signFlag);
                signFlag = setInterval(()=>{
                    let time = localStorage.getItem(CRM_LATEST_AJAX_TIME);
                    if(Date.now() - time > 1000 * 60 * 180){
                        if(self.extStatusId == 1){
                            return;
                        }
                        self.handleExtCommands('signOut');
                        clearInterval(signFlag);
                    }
                },1000 * 10);
            },
            onMessageList(){
                this.$router.push({ path: '/messageList'})
            },
            handleClick(tab) {
                for (let i in this.menu) {
                    if (tab.name == this.menu[i].NavigationId) {
                        if(this.menu[i].Path == 130520){
                            let UserId = JSON.parse(localStorage.getItem('CRM_USER_INFO')).UserId,sign
                            sign = calcMD5('SSO' + UserId)
                            let actionUrl = this.menu[i].Url + (this.menu[i].Url.indexOf('?') >= 0 ? '&' : '?') + 'sign=' + sign + '&id=' + UserId
                            location.href = actionUrl
                        } else if ((this.menu[i].Path == 1305201) || (this.menu[i].Path == "TMapAll")) {
                            window.open(this.menu[i].Url)
                        } else if (this.menu[i].Path == "supervise") {
                            GetSupervisionUrl().then(ret => {
                                if (ret.status === 0 && ret.result) {
                                    window.open(ret.result)
                                } else {
                                    this.$message({
                                        type: 'warning',
                                        message: ret.info || "获取链接失败"
                                    })
                                }
                            })
                        } else{
                            this.updateCurrentSubMenu(this.menu[i]);
                            this.$store.dispatch('updateCurrentSubMenu', this.menu[i].NavigationId);
                        }
                        return;
                    }
                }
            },
            updateCurrentSubMenu(item) {
                //this.$store.dispatch('updateCurrentSubMenu', item.NavigationId);
                if (item.ChildNavigations) {
                    let path = item.ChildNavigations[0].ChildNavigations ? item.ChildNavigations[0].ChildNavigations[0].Url : item.ChildNavigations[0].Url;
                    this.$router.push({
                        path,
                    });
                    setTimeout(() => {
                        this.$store.dispatch('updateCurrentTabId', path);
                    }, 0)
                }
            },
            handleCommands(command) {
                let prefix = getEnv();
                if (command == 'logout') {
                    UserLogOut()
                    setCookie(CRM_TOKEN, undefined, { expires: new Date(0) });
                    setCookie(`${prefix}GDSID`, undefined, { expires: new Date(0) });
                    const loginPageStatus = localStorage.getItem('loginPageStatus');
                    sessionStorage.removeItem(CRM_OPEN_TABS);
                    sessionStorage.removeItem(CRM_USER_DEPARTMENT);
                    sessionStorage.removeItem(CRM_PROVICE_CITY);
                    sessionStorage.removeItem(CRM_CLUES_STATUS);
                    sessionStorage.removeItem(CRM_INTENTION_DEGREE);
                    sessionStorage.removeItem(CRM_CUSTONER_SOURE);
                    sessionStorage.removeItem(CRM_CHANNERLS);
                    sessionStorage.removeItem(CRM_CLUES_OPTIMAL);
                    sessionStorage.removeItem(CRM_PROFESSIONAL_STATUS);
                    sessionStorage.removeItem(CRM_TRAFFIC_STATUS);
                    sessionStorage.removeItem(CRM_LABE_LIST);
                    sessionStorage.removeItem(CRM_URGENCY);
                    sessionStorage.removeItem(CRM_INTENTTION_DEGREE);
                    sessionStorage.removeItem(CRM_CERTIFICATES_TYPE);
                    sessionStorage.removeItem(CRM_INTENTION_STUDENTS);
                    localStorage.clear();
                    this.$store.state.navigation.currentLevelOneId = 489;
                    window.crmSocket && window.crmSocket.disconnect();
                    
                    // 如果是传统登录页，直接跳转到/login页面，否则直接关闭窗口
                    if (loginPageStatus === '1') {
                        window.close();
                    } else {
                        this.$router.push('/login');
                    }
                } else if (command == 'passwordModify') {
                    import("./PasswordModify.vue").then(PasswordModify => {
                        Modal.openComponent(PasswordModify.default, {
                            title: '修改密码',
                            showCancelButton: false,
                            showConfirmButton: false,
                            width: '500px',
                            self: this,
                        });
                    });
                } else if (command == 'extension') {
                    this.isExtension = true;
                } else if (command == 'qrCode') {
                    this.dialogVisible = true
                } else if (command == 'export') {
                    console.log("导出下载")
                    this.$router.push('/export')
                }
            },

            /**
             * 获取用户签入状态
             * URL /CallCenter/UserSign
             *
             * @param UserNo xxx
             * @param ExtNo  xxx
             * @param Operate 1：签入  2：签出  3：忙？  4：挂？
             * @param OperateType xxx
             */

            handleExtCommands(command) {//签入 签出
                // alert(command)
                let extInfo = {
                    UserNo: this.userInfo.UserId,
                    ExtNo: this.userInfo.PartialPhone,
                    Operate:0
                };
                switch (command) {
                    case "signIn":
                        extInfo.Operate = 1;
                        extInfo.OperateType = 1;
                        this.$store.dispatch('signOperate', extInfo);
                        break;
                    case "signOut":
                        extInfo.Operate = 2;
                        extInfo.OperateType = 1;
                        this.$store.dispatch('signOperate', extInfo);
                        break;
                    case "setIdle":
                        extInfo.Operate = 4;
                        extInfo.OperateType = 2;
                        this.$store.dispatch('signOperate', extInfo);
                        break;
                    case "setBusy":
                        extInfo.Operate = 3;
                        extInfo.OperateType = 2;
                        this.$store.dispatch('signOperate', extInfo);
                        break;
                    case "setMonitor":
                        this.$router.push({ path: '/callCenter/ExtMonitor' })
                        this.$store.dispatch('updateCurrentTabId', '/callCenter/ExtMonitor');
                        break;
                    case "setHangup":
                        hangupCall(this,extInfo.ExtNo);
                        break;
                    default:
                        break;
                }
                setTimeout(()=>{
                    if(this.userInfo.CallCenterType==2){
                        signAliYunCC(extInfo.Operate,this);
                    }else if(this.userInfo.CallCenterType==3){
                        signTianRunYunCC(extInfo.Operate, this);
                    }
                },2000)

            },
            onDialogSave() { // 保存话务配置
                const {system, PartialPhone} = this.form;
                if (system == '1' && PartialPhone == '') {
                    this.$message({
                        type: 'warning',
                        message: '分机号不能为空'
                    })
                    return;
                }
                let params = {
                    "UserId": this.userInfo.UserId,
                    "CallCenterType": system,
                    "ExtNo": PartialPhone
                }
                this.sysLoading = true;
                EditUser(params).then(ret => {
                    this.sysLoading = false;
                    if (ret.status == 0) {
                        this.isExtension = false;
                        this.$message({
                            type: 'success',
                            message: ret.info || '话务配置成功'
                        })
                        if (localStorage.getItem('CRM_USER_INFO')) {
                            let userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO'));
                            userInfo.CallCenterType = this.form.system.toString();
                            localStorage.setItem('CRM_USER_INFO', JSON.stringify(userInfo));
                        }

                    } else {
                        this.$message({
                            type: 'warning',
                            message: ret.info || '话务配置失败'
                        })
                    }
                })
            },

            // 设置签入状态
            setAliStatus(stateCode){
                this.setExtStatus(this.extStatusId);
                switch(this.aliCallStatus){
                    case 6:
                    case 8:
                    case 9:
                    case 10:
                        this.signIn = true;
                        this.singOut = true;
                        this.setIdle = true;
                        this.setBusy = true;
                        this.setMonitor = false;
                        this.setHangup = false;
                        this.extStatus = "通话中";
                        this.isCalling=1;
                        break;
                }
            },
            setTrStatus(statateName){//天潤
                this.setExtStatus(this.extStatusId);
                if(this.trCCEventName == "comeRinging" ||
                    this.trCCEventName == "normalBusy" ||
                    this.trCCEventName == "outRinging" ||
                    this.trCCEventName == "waitLink" ||
                    this.trCCEventName == "outBusy"||
                    this.trCCEventName=="stateRinging"){
                    this.signIn = true;
                    this.singOut = true;
                    this.setIdle = true;
                    this.setBusy = true;
                    this.setMonitor = false;
                    this.setHangup = false;
                    this.extStatus = "通话中";
                    this.isCalling=1;
                }
            },
            setTrCludeStatus(statateName){//天潤
                this.setExtStatus(this.extStatusId);
                if(this.trState == "呼叫中" ||
                    this.trState == "响铃" ||
                    this.trState == "通话"){
                    this.signIn = true;
                    this.singOut = true;
                    this.setIdle = true;
                    this.setBusy = true;
                    this.setMonitor = false;
                    this.setHangup = false;
                    this.extStatus = "通话中";
                    this.isCalling=1;
                }
            },
            setExtStatus: function(statusId) {//设置话机状态
                this.isCalling=0;
                // alert(statusId)
                switch (statusId) {
                    case 1:
                        this.signIn = false;
                        this.singOut = true;
                        this.setIdle = true;
                        this.setBusy = true;
                        this.setMonitor = true;
                        this.setHangup = true;
                        this.extStatus = "未签入";
                        break;
                    case 2:
                        this.signIn = true;
                        this.singOut = false;
                        this.setIdle = true;
                        this.setBusy = false;
                        this.setMonitor = false;
                        this.setHangup = true;
                        this.extStatus = "空闲中";
                        break;
                    case 3:
                        this.signIn = true;
                        this.singOut = false;
                        this.setIdle = false;
                        this.setBusy = true;
                        this.setMonitor = false;
                        this.setHangup = true;
                        this.extStatus = "忙碌中";
                        break;
                    case 4:
                        this.signIn = true;
                        this.singOut = true;
                        this.setIdle = true;
                        this.setBusy = true;
                        this.setMonitor = false;
                        this.setHangup = false;
                        this.extStatus = "通话中";
                        break;
                    default:
                        break;
                }

            },
            // 打电话
            sendCall() {
                this.$store.dispatch('callUp', {
                    UserNo: this.userInfo.UserId,
                    FromNo: this.userInfo.PartialPhone,
                    ToNo: this.callNum
                })
            },
            // 获取电话记录信息
            getCallInfo() {
                this.$store.dispatch('getCallInfo',{"extNo":this.userInfo.PartialPhone,"userId":this.userInfo.UserId})
            },
            //获取电话状态
            getExtStatus() {
                let queryPrm = { UserNo: this.userInfo.UserId, ExtNo: this.userInfo.PartialPhone };
                this.$store.dispatch('getExtStatus', queryPrm);
                if(this.userInfo.CallCenterType==2){
                    //  setTimeout(() => {
                    //         window.workbench.logIn();
                    //         this.initAliCCStatus();
                    //     }, 3000);
                }else if(this.userInfo.CallCenterType==3){
                    // setTimeout(() => {
                    //     if(window.executeAction){
                    //         tianrunCCLogin();
                    //         this.initTianRunCCStatus();
                    //     }
                    // }, 2000);
                }else if(this.userInfo.CallCenterType==4){
                     setTimeout(() => {
                        getCallStatus([{Cno:this.userInfo.HanTianCno,CallCenterType:this.userInfo.CallCenterType,UserId:this.userInfo.UserId}]).then(ret=>{
                            if(ret.status==0){
                                if(ret.result&&ret.result[0].CallStatus==1){
                                    this.$store.dispatch("updateTrCludeStatus", {state: "呼叫中",stateAction: 'calling', customerNumber: ''});
                                }
                            }
                        }).catch(()=>{

                        })
                    }, 1000);
                }
            },
            initTianRunCCStatus(){
                switch(this.extStatusId){
                    case 1:
                        window.executeAction("doLogout",{"type":"1"});
                        break;
                    case 2:
                        window.executeAction('doUnpause');
                        break;
                    case 3:
                        window.executeAction('doPause', {"description":"置忙"});
                        break;
                    case 4:
                        break;
                }
            }
        }
    }
</script>
<style  lang="less">
    .header-logo {
        text-indent: -9999px;
        height: 100%;
        background: url('../../img/logo1.png') 50% 50% no-repeat;
        background-size: 80%;
    }
    .qr_img {
        width: 100%;

    }
    .el-dialog .el-dialog__header {
        background-color: #fff !important;
    }
    .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
        color: #000 !important;
    }
    .el-dialog__body {
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }
</style>
<style>
    @media screen and (max-width: 800px) {
        .info-messge {
            display: none;
        }
    }

    .crm-system-msg {
        font-size: 12px;
        color: red;
        margin-left: 25px;
    }
    /*.nav-extension .el-dialog--small {*/
        /*width: 35%;*/
    /*}*/
    /*.crm-navigation .el-tabs {*/
        /*float: left;*/
    /*}*/

    .crm-navigation .el-dropdown-menu__item {
        text-align: center;
    }

    .crm-navigation .el-tabs__item {
        color: #fff;
        font-size: 12px;
        height: 50px;
        line-height: 50px;
        transition: all .5s;
        min-width: 70px;
        padding: 0 8px!important;
        text-align: center;
    }
    .navBox .el-tabs__item.is-active {
        background-color: #1796cf;
    }
    .crm-navigation .el-tabs__item,
    .crm-navigation .el-tabs__item.is-active {
        color: #fff!important;
    }

    /*.crm-navigation .el-tabs__content {*/
        /*display: none;*/
    /*}*/

    .crm-navigation .el-tabs__active-bar {
        /*width: 80px;*/
        /*text-align: center;*/
        /*height: 50px;*/
        /*z-index: 0;*/
        /*background: #1796cf;*/
        /*top: -1px;*/
    }

    .crm-navigation .el-tabs__item:hover {
        color: #fff;
        background: #17A7E8;
    }
    .crm-navigation .el-tabs__header {
        border: 0 none;
        margin-bottom: 0!important;
    }
    .crm-navigation .el-tabs__nav-prev, .crm-navigation .el-tabs__nav-next {
        color: #fff;line-height: 50px;

    }
</style>
